/** Internal (warranty/repair on an existing deal) vs sold (new service sale, own deal). */

export type ServiceJobKind = "internal" | "sold";

const INTERNAL_ORIGINS = new Set(["service_internal", "manufacturing_auto"]);

export function inferServiceJobKind(origin: string | null | undefined): ServiceJobKind {
  if (origin && INTERNAL_ORIGINS.has(origin)) return "internal";
  return "sold";
}

export function originForJobKind(kind: ServiceJobKind): "service_internal" | "sales" {
  return kind === "internal" ? "service_internal" : "sales";
}

export function serviceJobKindLabel(kind: ServiceJobKind | string | null | undefined): string {
  return kind === "internal" ? "Internal" : "Sold";
}

export function parseQuotedAmountCents(raw: string): number | null {
  const trimmed = raw.replace(/[$,]/g, "").trim();
  if (!trimmed) return null;
  const n = Number(trimmed);
  if (!Number.isFinite(n) || n < 0) return null;
  return Math.round(n * 100);
}

export function parseOpsDealId(raw: unknown): string | null {
  if (typeof raw !== "string") return null;
  const id = raw.trim();
  if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id)) return null;
  return id;
}
